$(document).ready(function(){
  $('.color_container').click(function() {
      // Log the URL to the console
      console.log($(this).data('url'));
      // Redirect to the new URL
    //debugger;
      window.location.href = window.location.origin + $(this).data('url');
  });

  
   $('.sidecart-complete-set-righttext .variant-picker__option-values input').on('change', function() {
      $('.sidecart-complete-set-righttext .variant-picker__option-values input').attr('checked', false);
      $(this).push('checked', true).attr('checked', 'checked');
      if ($(this).is(':checked')) {
          var proVar = $(this).attr('data-variant-id');  // Corrected from 'data-varinat--id' to 'data-variant-id'
          $('.sidecart-complete-set-righttext form.shopify-product-form input[name="id"]').val(proVar);
      }
  });
  // $('.custom-cart-drawer .complete-set__button button').click(function(){
  //   //debugger;
  //   //var get_id = $(this).parents('.complete-set__text').find('.complete-set__button').find('input[name="id"]').attr('data-varinat--id');
  //   var get_id = $(this).parents('.complete-set__text').find('.variant-selector-wrapper variant-picker').find('input:checked').attr('data-varinat--id');
  //   var quantity = 1;
  //   var data = {
  //     id: get_id,
  //     quantity: quantity
  //   };
  //   event.preventDefault();
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: data,
  //     dataType: 'json',
  //     success: function(data) {
  //       setTimeout(function() {
  //         location.reload();
  //       },500)
  //     },
  //     error: function() {
  //       //alert('Error in AJAX call!');
  //     }     		  
  //   }); 
  // });
});

// $(function() {
//   $('.accordion summary').click(function() {
//     alert('accordian working');
//     var accordion = $(this).parent(); // Get the parent <details> element

//     // Toggle the 'open' attribute of the accordion
//     if (accordion.attr('open')) {
//       accordion.removeAttr('open');
//     } else {
//       accordion.attr('open', 'true');
//     }

//     // Close other accordions
//     $('.accordion').not(accordion).each(function() {
//       $(this).removeAttr('open');
//     });
//   });
// });
document.addEventListener('DOMContentLoaded', function() {
  // Select all summary elements within elements with the .accordion class
  var summaries = document.querySelectorAll('.custom-main-product .accordion summary');

  summaries.forEach(function(summary) {
    summary.addEventListener('click', function() {
      // alert('accordion working');

      var accordion = this.parentElement; // Get the parent <details> element

      // Toggle the 'open' attribute of the accordion
      if (accordion.getAttribute('open')) {
        accordion.removeAttribute('open');
      } else {
        accordion.setAttribute('open', 'true');
      }

      // Close other accordions
      var allAccordions = document.querySelectorAll('.accordion');
      allAccordions.forEach(function(item) {
        if (item !== accordion && item.hasAttribute('open')) {
          item.removeAttribute('open');
        }
      });
    });
  });
});




$(document).ready(function () {
   // Header Height get js
    const header = $('.custom-header .header');
    const headerHeight = header.outerHeight();
    $('.collection-filter__wrapper').css('top', headerHeight + 'px');
    console.log(`Header height: ${headerHeight}px`);



    const header1 = $('.custom-header .header');
    const headerHeight1 = header.outerHeight();
    $('.search-top-stickeybar').css('top', headerHeight1 + 'px');
    console.log(`Header height: ${headerHeight1}px`);

  
      $('li.submenu-wrapper span.down-arrow').click(function(e) {
        e.preventDefault();
        var $submenuWrapper = $(this).closest('li.submenu-wrapper');
        var $submenu = $submenuWrapper.find('> .submenu');
        
        if ($submenu.is(':visible')) {
            $submenu.slideUp('slow', function() {
                $submenuWrapper.removeClass('active');
            });
        } else {
            $('.submenu').slideUp('slow'); // Close other open submenus
            $('li.submenu-wrapper').removeClass('active'); // Remove active class from other menu items
            
            $submenu.slideDown('slow', function() {
                $submenuWrapper.addClass('active');
            });
        }
    });

    $('li.sub-childmenu span.down-arrows').click(function(e) {
        e.preventDefault();
        var $submenuWrapper = $(this).closest('li.sub-childmenu');
        var $submenu = $submenuWrapper.find('> .sub-child');
        
        if ($submenu.is(':visible')) {
            $submenu.slideUp('slow', function() {
                $submenuWrapper.removeClass('active');
            });
        } else {
            $('.sub-child').slideUp('slow'); // Close other open submenus
            $('li.sub-childmenu').removeClass('active'); // Remove active class from other menu items
            
            $submenu.slideDown('slow', function() {
                $submenuWrapper.addClass('active');
            });
        }
    });
  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: ".slider-nav",
    infinite: false,
    dots: true,
    arrows: false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-left-slider-arrow.png?v=1719402708"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-right-slider-arrow.png?v=1719402707"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
        },
      },
    ],
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: true,
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true,
    infinite: false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/left-arrow-slider.png?v=1719384457"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/right-arrow-slider.png?v=1719384548"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: "0px",
          arrows: true,
          vertical: false,
        },
      },
    ],
  });

  
  $(".custom-logo-tabbing-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: ".custom-logo-tabbing-nav",
    infinite: false,
    dots: false,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    draggable:false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-left-slider-arrow.png?v=1719402708"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-right-slider-arrow.png?v=1719402707"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  });
  $(".custom-logo-tabbing-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".custom-logo-tabbing-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    draggable:false,
     variableWidth: true,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-left-arrow.png?v=1719410232"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-right-arrow.png?v=1719410232"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          dots:true,
             adaptiveHeight: true,
        },
      },
    ],
  });
  // $(".announcement-bar__wrapper").slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   speed: 4000,
  //   pauseOnHover: false,
  //   cssEase: "linear",
  //   arrows: false,
  //   variableWidth: true,
  // });
    $(".announcement-bar__wrapper").slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
  });
  $(".banner-section__wrapper").slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    adaptiveHeight: true,
  });
  // $(".feature-hightlight__wrapper").slick({
  //   slidesToScroll: 1,
  //   infinite: false,
  //   arrows: false,
  //   dots: true,
  //   vertical: true,
  //   verticalSwiping: true,
  //   responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         vertical: false,
  //         verticalSwiping: false,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         vertical: false,
  //         verticalSwiping: false,
  //       },
  //     },
  //   ],
  // });
  // Slick Scroll

  $(".like-us__leftwrapper").slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: false,
  });
  $(".custom-product-multi-column multi-column.multi-column").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,

          dots: true,
        },
      },
    ],
  });
  $(".custom-two-collection .collection-list").slick({
    slidesToShow: 2,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,

          dots: false,
        },
      },
    ],
  });
  $(".custom-three-collection .collection-list").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,

          dots: false,
        },
      },
    ],
  });
    $(".custom-blog__wrapper").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  });
  $(".custom-featured-collection .featured-collections-carousel__item .product-list").slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.14,
          slidesToScroll: 1,

          dots: false,
        },
      },
    ],
  });
  // $(".custom-mobile-shop-slider").slick({
  //   slidesToShow: 1,
  //   infinite: false,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   dots: true,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         dots: false,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         dots: false,
  //       },
  //     },
  //   ],
  // });

  // Check if the screen width is less than or equal to 767px
  function initializeSlickSlider() {
    if ($(window).width() <= 767) {
      $(".blue-capsule__rightwrapper").slick({
        slidesToShow: 2.1,
        infinite: false,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: false,
      });
    }
  }
  initializeSlickSlider();
  $(window).on("resize", function () {
    // Destroy the slider if it's initialized
    if ($(".blue-capsule__rightwrapper").hasClass("slick-initialized")) {
      $(".blue-capsule__rightwrapper").slick("unslick");
    }
    // Call the function to initialize the slider again
    initializeSlickSlider();
  });

  function logoslickslider() {
    if ($(window).width() <= 767) {
      $(".custom-logo-list .logo-list").slick({
        slidesToShow: 1,
        infinite: false,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        adaptiveHeight: true,
        arrows: false,
      });
    }
  }
  logoslickslider();
  $(window).on("resize", function () {
    // Destroy the slider if it's initialized
    if ($(".custom-logo-list .logo-list").hasClass("slick-initialized")) {
      $(".custom-logo-list .logo-list").slick("unslick");
    }
    // Call the function to initialize the slider again
    logoslickslider();
  });

  $(".wear-product__wrapper").slick({
    slidesToShow: 3,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  //      $(".custom-related .section-spacing product-list.product-list").slick({
  //   slidesToShow: 4,
  //   infinite: false,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   dots: false,
  //   arrows:false,
  //    draggable:false,
  //      responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,

  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2.2,
  //         slidesToScroll: 1,

  //       },
  //     },
  //   ],
  // });

  chatinterval = setInterval(function () {
    var slider = $(".custom-related .section-spacing product-list.product-list").length;
    console.log(slider);
    if (slider == 1) {
      // console.log("Apply Slider");
      $(".custom-related .section-spacing product-list.product-list").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.2,
              slidesToScroll: 1,
            },
          },
        ],
      });
      clearInterval(chatinterval);
    } else {
      // console.log("Not Get Product Div");
    }
  }, 1000);

  // chatinterval = setInterval(function () {
  //   var slider = $(".custom-mobile-shop-slider").length;
  //   console.log(slider);
  //   if (slider == 1) {
  //     console.log("Apply mobile Slider");
  //     $(".custom-mobile-shop-slider").slick({
  //       dots: false,
  //       infinite: false,
  //       speed: 300,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       responsive: [
  //         {
  //           breakpoint: 991,
  //           settings: {
  //             slidesToShow: 2,
  //             slidesToScroll: 1,
  //           },
  //         },
  //         {
  //           breakpoint: 768,
  //           settings: {
  //             slidesToShow: 2.2,
  //             slidesToScroll: 1,
  //           },
  //         },
  //       ],
  //     });
  //     clearInterval(chatinterval);
  //   } else {
  //     console.log("Not apply mobile slider");
  //   }
  // }, 1000);

  // $(".custom-mobile-shop-slider").slick({
  //   slidesToShow: 1,
  //   infinite: false,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   dots: false,
  //   arrows: false,
  // });
 
});

$(document).ready(function(){
   $('.sidecart-complete-set-righttext .variant-picker__option-values input').on('change', function() {
      $('.sidecart-complete-set-righttext .variant-picker__option-values input').attr('checked', false);
      $(this).push('checked', true).attr('checked', 'checked');
      if ($(this).is(':checked')) {
          var proVar = $(this).attr('data-variant-id');  // Corrected from 'data-varinat--id' to 'data-variant-id'
          $('.sidecart-complete-set-righttext form.shopify-product-form input[name="id"]').val(proVar);
      }
  });

  $('button.shop-the-look__hot-spot').click(function(){
    // alert("shop clicked");
    $('.custom-mobile-shop-slider').slick('refresh');
    });
  $(".custom-mobile-shop-slider").slick({
    slidesToShow: 1.2,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: false,
  });
  
});   


// countdown js

var geMDate = $(".preorder-timer").attr("data-timer");
var countdownDate = new Date(geMDate);

// var countdownDate = new Date();

  // countdownDate.setDate(countdownDate.getDate(geMDate));

// countdownDate.setDate(countdownDate.getDate());
// countdownDate.setMinutes(countdownDate.getMinutes() + 28);
// countdownDate.setSeconds(countdownDate.getSeconds() + 15);


// Update the countdown every second
var countdown = setInterval(function() {
    var now = new Date().getTime();
    var distance = countdownDate.getTime() - now;

    var new_days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var new_hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var new_minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var new_seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var formattedDays = new_days.toString().padStart(2, '0');
  var formattedHours = new_hours.toString().padStart(2, '0');
  var formattedMinutes = new_minutes.toString().padStart(2, '0');
  var formattedSeconds = new_seconds.toString().padStart(2, '0');
    
    // document.querySelector('.site-header .js-timer-days').innerText = Math.floor(distance / (day)),
      document.querySelector('#days').innerText = formattedDays;
      document.querySelector('#hours').innerText = formattedHours;
      document.querySelector('#minutes').innerText = formattedMinutes;
     document.querySelector('#seconds').innerText = formattedSeconds
    
  
  
    // Display the countdown in the element with id="countdown"
    // $("#days").text(formatNumber(days));
    // $("#hours").text(formatNumber(hours));
    // $("#minutes").text(formatNumber(minutes));
    // $("#seconds").text(formatNumber(seconds));

    // If the countdown is over, clear the interval and display a message
    if (distance < 0) {
        clearInterval(countdown);
        $("#countdown").html("<p>Countdown complete!</p>");
    }
}, 1000); // Update every second (1000 milliseconds)

// Function to format numbers (add leading zero if necessary)
function formatNumber(number) {
    return (number < 10 ? '0' : '') + number;
}


// $(".feature-hightlight__wrapper").slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows : false,
//   vertical: true,
//   verticalSwiping: true,
//   infinite: false,
//   dots:true,
// });


$(document).ready(function() {
  // Initialize slick slider
  $(".feature-hightlight__wrapper").slick({
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          vertical: false,
          verticalSwiping: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false
        }
      }
    ]
  });

  // Bind wheel event to the slick slider
  
 if ($(window).width() > 990) {
      $(".feature-hightlight__wrapper").on("wheel", function(e) {
    e.preventDefault(); // Prevent default wheel behavior (scrolling page)

    // Determine scroll direction
    if (e.originalEvent.deltaY < 0) {
      $(this).slick("slickPrev");
      
    } else {
      $(this).slick("slickNext");
    }
  });
  }
  
  $(window).resize(function(){
   if ($(window).width() > 990) {
        $(".feature-hightlight__wrapper").on("wheel", function(e) {
    e.preventDefault(); // Prevent default wheel behavior (scrolling page)

    // Determine scroll direction
    if (e.originalEvent.deltaY < 0) {
      $(this).slick("slickPrev");
      
    } else {
      $(this).slick("slickNext");
    }
  });
    }
  });

  

});
// $(".custom-product-slider-for").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: false,
//     asNavFor: ".custom-product-slider-nav",
//     infinite: false,
//     dots: false,
//     arrows: false,
//     fade: true,
//     prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-left-slider-arrow.png?v=1719402708"></button>`,
//     nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-right-slider-arrow.png?v=1719402707"></button>`,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           arrows: true,
//         },
//       },
//     ],
//   });
//   $(".custom-product-slider-nav").slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     asNavFor: ".custom-product-slider-for",
//     dots: false,
//     arrows: true,
//     focusOnSelect: true,
//     infinite: false,
//     prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-left-arrow.png?v=1719410232"></button>`,
//     nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-right-arrow.png?v=1719410232"></button>`,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots:true,
//         },
//       },
//     ],
//   });
$(document).ready(function() {
  // Initialize the slick slider for navigation
  $(".custom-product-slider-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    asNavFor: ".custom-product-slider-for",
    dots: false,
    arrows: true,
    focusOnSelect: true,
    infinite: false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-left-arrow.png?v=1719410232"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/tab-slider-right-arrow.png?v=1719410232"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
        },
      },
    ],
  });

  // Initialize the slick slider for the main content
  $(".custom-product-slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: ".custom-product-slider-nav",
    infinite: false,
    dots: false,
    arrows: false,
    
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-left-slider-arrow.png?v=1719402708"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-right-slider-arrow.png?v=1719402707"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
        },
      },
    ],
  });

  // Add a class if there are less than 3 items shown in the navigation slider


  // Bind wheel event to the slick slider
  if ($(window).width() > 990) {
    $(".custom-product-slider-for").on("wheel", function(e) {
      e.preventDefault(); // Prevent default wheel behavior (scrolling page)

      // Determine scroll direction
      if (e.originalEvent.deltaY < 0) {
        $(this).slick("slickPrev");
      } else {
        $(this).slick("slickNext");
      }
    });
  }

  // Re-bind wheel event on window resize
  $(window).resize(function(){
    if ($(window).width() > 990) {
      $(".custom-product-slider-for").on("wheel", function(e) {
        e.preventDefault(); // Prevent default wheel behavior (scrolling page)

        // Determine scroll direction
        if (e.originalEvent.deltaY < 0) {
          $(this).slick("slickPrev");
        } else {
          $(this).slick("slickNext");
        }
      });
    }
  });

});

var getCurrenturl = $('.product-info').attr("data-product-handle");
$('.product-info').find('[data-block-type="variant-picker"] .catgory-wrapper li').each(function(){
 var geturl = $(this).find("a").attr("href");
  if (getCurrenturl == geturl || geturl == '#') {
    $(this).addClass("active");
    var getValue = $(this).find('a').text();
    getValue = getValue.replace("/ ", "");
    var inputMaterial = '<input type="hidden" id="matirials_2" name="properties[Material]" value="'+ getValue +'">';
    $('.shopify-product-form').prepend(inputMaterial);
  }else{
    $(this).removeClass("active");
  }
});

(function() {
  function replaceJdgmH3() {
    document.querySelectorAll('h3.jdgm-rev-widg__section-title').forEach(function(h3) {
      var p = document.createElement('p');
      Array.from(h3.attributes).forEach(function(attr) {
        p.setAttribute(attr.name, attr.value);
      });
      p.innerHTML = h3.innerHTML;
      h3.parentNode.replaceChild(p, h3);
    });
  }

  if (document.readyState !== 'loading') {
    replaceJdgmH3();
  } else {
    document.addEventListener('DOMContentLoaded', replaceJdgmH3);
  }

  var observer = new MutationObserver(function() {
    replaceJdgmH3();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();